import { jsx as _jsx } from "react/jsx-runtime";
import TourHomeLoader from './components/tour-home-loader';
import TourHomeContent from './components/home/tour-home-content';
// One house on a tour, as an attendee walking the route (or touring from home) opens it.
const TourHomePage = (props) => _jsx(TourHomeLoader, { id: props.id, stopId: props.stopId, children: data => _jsx(TourHomeContent, { data: data }) });
export default TourHomePage;
